import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { FETCH_MATERIALS_DATA, FETCH_MATERIALS_EDIT_DATA } from "./actionTypes";
import {
  fetchMaterialsSuccess,
  fetchMaterialsFailure,
  fetchMaterialsEditSuccess,
  fetchMaterialsEditFailure,
} from "./actions";

function* fetchMaterialsDataSaga() {
  try {
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + "/api/web/materials",{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchMaterialsSuccess(response.data));
  } catch (error) {
    yield put(fetchMaterialsFailure(error.message));
  }
}

function* fetchMaterialsEditDataSaga(action) {
  try {
    const id = action.payload;
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + `/api/web/materials/${id}`,{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchMaterialsEditSuccess(response.data));
  } catch (error) {
    yield put(fetchMaterialsEditFailure(error.message));
  }
}

export default function* materialsSaga() {
  yield takeEvery(FETCH_MATERIALS_DATA, fetchMaterialsDataSaga);
  yield takeEvery(FETCH_MATERIALS_EDIT_DATA, fetchMaterialsEditDataSaga);
}
